import React from "react";
import PhoneInputComponent, { Country, Value } from "react-phone-number-input";
import "./PhoneInput.styles.scss";

type Props = {
  onChange: (phone?: string) => void;
  value?: string;
  placeholder: string;
  defaultCountry?: Country | string;
  testId?: string;
  /** Reads digits typed without a + as a national number in the selected country. */
  acceptNationalFormat?: boolean;
  countries?: Country[];
};

const PhoneInput: React.FC<Props> = ({
  onChange,
  value,
  placeholder,
  defaultCountry = "GB",
  testId = "phone-input",
  acceptNationalFormat = false,
  countries,
}) => (
  <PhoneInputComponent
    data-testid={testId}
    international={acceptNationalFormat ? undefined : true}
    countries={countries}
    value={value as Value | undefined}
    placeholder={placeholder}
    defaultCountry={defaultCountry as Country}
    onChange={onChange}
  />
);

export default PhoneInput;
export type { Country };
